import React, { useRef, useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';
import { MASK } from '../../../../constants/mask';
import useIbanAutofill from '../../../../hooks/useIbanAutofill';

const RequisitesForm = ({ onSubmit, currentData }) => {
  const [requisitesForm, setRequisitesForm] = useState([
    {
      name: 'bankAccount',
      label: 'ÐÐ¾Ð¼ÐµÑ Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ ÑÑÑÑÐ°',
      placeholder: 'KZT5004100100',
      rules: { 
        required: true,
        validate: (value) => {
          value = value.replace(/_/g, '');
          if (!value || value.length !== 20) {
            return 'ÐÐ¾Ð¼ÐµÑ Ð±Ð°Ð½ÐºÐ¾Ð²ÑÐºÐ¾Ð³Ð¾ ÑÑÑÑÐ° Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 20 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²';
          }
          return true;
        }
      },
      mask: MASK.IBAN,
      defaultValue: currentData?.bankAccount,
    },
    {
      name: 'bankName',
      label: 'ÐÐ°Ð¸Ð¼ÐµÐ½Ð¾Ð²Ð°Ð½Ð¸Ðµ Ð±Ð°Ð½ÐºÐ°',
      placeholder: 'ÐÐ "ÐÐ°Ð½Ðº"',
      rules: { required: true },
      defaultValue: currentData?.bankName,
    },
    {
      name: 'bankBic',
      label: 'ÐÐÐ',
      placeholder: 'KCJBKZKX',
      rules: { 
        required: true,
        validate: (value) => {
          value = value?.replace(/_/g, '');
          if (!value || value?.length !== 8) {
            return 'ÐÐÐ Ð´Ð¾Ð»Ð¶ÐµÐ½ ÑÐ¾Ð´ÐµÑÐ¶Ð°ÑÑ 8 ÑÐ¸Ð¼Ð²Ð¾Ð»Ð¾Ð²';
          }
          return true;
        }
      },
      mask: [/[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/, /[A-Za-z]/],
      maxLength: 8,
      defaultValue: currentData?.bankBic,
      transform: (value) => value?.toUpperCase(),
    },
    // {
    //   name: 'bankAddress',
    //   label: 'ÐÐ´ÑÐµÑ Ð±Ð°Ð½ÐºÐ°',
    //   placeholder: 'Ð³. ÐÐ»Ð¼Ð°ÑÑ, ÑÐ». ÐÐ°Ð½ÐºÐ¾Ð²ÑÐºÐ°Ñ, Ð´. 1',
    //   rules: { required: true },
    //   value: currentData?.bankAddress,
    // },
    // {
    //   name: 'correspondentAccount',
    //   label: 'ÐÐ¾ÑÑÐµÑÐ¿Ð¾Ð½Ð´ÐµÐ½ÑÑÐºÐ¸Ð¹ ÑÑÑÑ',
    //   placeholder: 'KZ987654321098765432',
    //   value: currentData?.correspondentAccount,
    // },
    // {
    //   name: 'kbe',
    //   label: 'ÐÐÐµ (ÐºÐ¾Ð´ Ð½Ð°Ð·Ð½Ð°ÑÐµÐ½Ð¸Ñ Ð¿Ð»Ð°ÑÐµÐ¶Ð°)',
    //   placeholder: '17',
    //   type: 'select',
    //   options: [
    //     { value: '17', label: '17 - Ð¢ÐµÐºÑÑÐ¸Ð¹ ÑÑÑÑ' },
    //     { value: '15', label: '15 - ÐÐµÐ¿Ð¾Ð·Ð¸ÑÐ½ÑÐ¹ ÑÑÑÑ' },
    //     { value: '19', label: '19 - ÐÑÐ¾ÑÐ¸Ðµ ÑÑÐµÑÐ°' },
    //   ],
    //   rules: { required: true },
    //   value: currentData?.kbe,
    // },
    // {
    //   name: 'accountCurrency',
    //   label: 'ÐÐ°Ð»ÑÑÐ° ÑÑÑÑÐ°',
    //   type: 'select',
    //   options: [
    //     { value: 'KZT', label: 'Ð¢ÐµÐ½Ð³Ðµ (KZT)' },
    //     { value: 'USD', label: 'ÐÐ¾Ð»Ð»Ð°Ñ Ð¡Ð¨Ð (USD)' },
    //     { value: 'EUR', label: 'ÐÐ²ÑÐ¾ (EUR)' },
    //     { value: 'RUB', label: 'Ð Ð¾ÑÑÐ¸Ð¹ÑÐºÐ¸Ð¹ ÑÑÐ±Ð»Ñ (RUB)' },
    //   ],
    //   rules: { required: true },
    //   value: currentData?.accountCurrency || 'KZT',
    // },
    // {
    //   name: 'paymentPurpose',
    //   label: 'ÐÐ°Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¿Ð»Ð°ÑÐµÐ¶Ð°',
    //   placeholder: 'ÐÐ¿Ð»Ð°ÑÐ° Ð·Ð° Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ Ð¿Ð¾ Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÑ Ð²ÑÐºÑÐ¿Ð°',
    //   value: currentData?.paymentPurpose,
    // },
  ]);

  const formRef = useRef(null);
  // ÐÐ¾Ð»Ñ Ð·Ð´ÐµÑÑ Ð½Ð°Ð·Ð²Ð°Ð½Ñ Ð¸Ð½Ð°ÑÐµ, ÑÐµÐ¼ Ð² Ð´Ð¾Ð³Ð¾Ð²Ð¾ÑÐµ Ð¿Ð¾ÑÑÑÐµÐ½Ð¸Ñ, â Ð¿ÐµÑÐµÐ´Ð°ÑÐ¼ ÑÐ²Ð¾Ð¸ Ð¸Ð¼ÐµÐ½Ð°.
  const ibanAutofill = useIbanAutofill(formRef, {
    iban: 'bankAccount',
    bank: 'bankName',
    bic: 'bankBic',
  });

  const handleSubmit = (values) => {
    if (onSubmit) {
      onSubmit(values);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        ref={formRef}
        onValuesChange={ibanAutofill}
        inputs={requisitesForm}
        title={'ÐÐ°Ð½ÐºÐ¾Ð²ÑÐºÐ¸Ðµ ÑÐµÐºÐ²Ð¸Ð·Ð¸ÑÑ'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr 1fr' }}
        handlerSetState={setRequisitesForm}
        onSubmit={handleSubmit}
        action={'ÐÐ°Ð»ÐµÐµ'}
        border
      />
    </div>
  );
};

export default RequisitesForm; 